import React, { useContext } from "react";
import style from "./index.module.scss";
import { Spin } from "antd";
import CustomEmpty from "components/CustomEmpty";
import ListItem from "./Components/ListItem";
import { CourseContext } from "../Store";
import useRequest from "../../../Utils/useRequest";
import { getQuestionnaireList } from "./service";

export default function Questionnaire() {
    const { basename, course } = useContext(CourseContext);
    const weekTimeId = course.weekTimeId;
    const courseId = course.courseId;
    const courseNo = course.courseNo;
    const courseSeq = course.courseSeq;
    const [data, { loading }, doFn] = useRequest(
        () => getQuestionnaireList(courseId, courseNo, courseSeq, weekTimeId),
        {},
        [courseId, courseNo, courseSeq, weekTimeId]
    );

    return (
        <div className={style.root}>
            <div className={style.header}>
                <div className={style.count}>问卷（{data?.length || 0}）</div>
            </div>

            <Spin spinning={false}>
                {data &&
                    data.length !== 0 &&
                    data.map(item => (
                        <ListItem
                            data={item}
                            key={item.id}
                            basename={basename}
                        />
                    ))}
                {!data?.length && (
                    <CustomEmpty style={{ padding: "100px 0" }} />
                )}
            </Spin>
        </div>
    );
}
